export enum ClassEligibilityStatus {
  ELIGIBLE = "ELIGIBLE",
  ENROLLED = "ENROLLED",
  INELIGIBLE = "INELIGIBLE",
  PURCHASE_HOLD = "PURCHASE_HOLD",
  UNKNOWN = "UNKNOWN",
  WAITLISTED = "WAITLISTED",
  WAITLISTED_PENDING = "WAITLISTED_PENDING",
}
